<template>
  <div :class="getClass()">
    <div class="toggle_box__header">
      <div class="toggle_box__header_actions">
        <a class="toggler" @click="toggle">
          <Icon v-show="closed && !lockedOpen" name="right" size="xsmall"></Icon>
          <Icon v-show="!closed || lockedOpen" name="down" size="xsmall"></Icon>
        </a>
      </div>
      <div class="toggle_box__header__content">
        <slot
          :isClosed="closed && !lockedOpen"
          :toggle="toggle"
          :open="open"
          :close="close"
          name="header"
        >
        </slot>
      </div>
    </div>
    <transition name="fade">
      <div v-show="!closed || lockedOpen" class="toggle_box__content">
        <slot :isClosed="closed" :toggle="toggle" :open="open" :close="close" name="default">
        </slot>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import Icon from "@/design-system/elements/Icon.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ToggleBox",
  components: {
    Icon,
  },
  props: {
    closedState: {
      type: Boolean,
      required: true,
    },
    classes: {
      type: String,
      required: false,
    },
    lockedOpen: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      closed: false,
    };
  },
  watch: {
    closedState(state: boolean) {
      if (!this.lockedOpen) {
        this.closed = state;
      } else {
        this.closed = false;
      }
    },
    lockedOpen(state: boolean) {
      if (state) {
        this.closed = false;
      }
    },
  },
  methods: {
    getClass(): string {
      return `toggle_box__wrapper ${this.classes ? this.classes : ""}`.trim();
    },
    toggle(): void {
      if (!this.lockedOpen) {
        this.closed = !this.closed;
        this.$emit("changed", this.closed);
      }
    },
    open(): void {
      if (!this.lockedOpen) {
        this.closed = false;
        this.$emit("changed", this.closed);
      }
    },
    close(): void {
      if (!this.lockedOpen) {
        this.closed = true;
        this.$emit("changed", this.closed);
      }
    },
  },
});
</script>

<style lang="scss">
.toggle_box__wrapper {
  .toggle_box__header {
    padding: 0;
    margin: 0;
    .toggle_box__header_actions {
      width: 16px;
      height: 16px;
      display: table-cell;
      vertical-align: top;
      padding-top: 5px;
    }
    .toggle_box__header__content {
      display: table-cell;
      height: 16px;
      overflow: hidden;
      width: 100%;
    }
  }
  .toggle_box__content {
    padding-left: 16px;
    margin: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
